module.exports = __webpack_public_path__ + "static/og-image-services-7e40daa273357280d7954725d0007553.png";